import React, { useEffect, useState } from 'react'
import Layout from './Layout'
import useApiUrlTranslation from './useApiUrlTranslation';
import { useParams } from "react-router-dom";

const Highligths = () => {

    const { idEvent } = useParams();

    const { t, i18n, apiUrlTranslation, } = useApiUrlTranslation();

    const { destinationList } = useParams();
    const [carrouselList, setCarrouselList] = useState(null);

    const [pageTitle, setPageTitle] = useState(null);

    const getCarrousel = async () => {

        // destinatinList is like 'aaaaa,bbbbb,ccccc' transformer en emplacement LIKE '%aaaaa%' OR emplacement LIKE '%bbbbb%' OR emplacement LIKE '%ccccc%'

        //si destinatinList de contient pas de virgule, on ne fait pas de recherche sur les destinations

        const destinations = destinationList && destinationList.includes(',') ? destinationList.split(',').map(dest => `emplacements LIKE '%${dest}%'`).join(' OR ') : `emplacements LIKE '%${destinationList}%'`

        await fetch(`${apiUrlTranslation}?action=getCarrousel&filter=WHERE id_event=${idEvent} AND ( ${destinations}) ORDER BY ordre_affichage ASC`)
            .then(res => res.json())
            .then(res => setCarrouselList(res))
    }

    useEffect(() => {
        getCarrousel();

        setPageTitle(destinationList === 'bilan' ? "Bilan : Les chiffres clés" : "Les temps forts de l'événement");

    }, [i18n.resolvedLanguage])


    return (
        <Layout title={pageTitle}>

            <div className='bg-white px-10'>

                {carrouselList && carrouselList.map((carrousel, index) =>
                    <div key={index} className="px-5 mx-auto flex   bg-white  shadow  py-3 my-2 rounded-lg">

                        <div className='basis-2/6'>
                            <img src={carrousel.files.source} alt="" className='rounded-lg' />
                        </div>
                        <div className="basis-4/6 bg-white p-5 rounded-lg ">
                            <div className="text-2xl font-bold mb-4">{carrousel.titre}</div>
                            <p>{carrousel.descriptif}</p>
                        </div>
                    </div>
                )}</div>

        </Layout>
    )
}

export default Highligths